module.exports = "https://cdn.realtymogul.com/static/media/img_hero_whyreits.9e492f5f.jpg";